import Vue from 'vue'
import errorHandling from './exceptions'
import { PRODUCTS } from '@/api'

const headers = { 'Content-Type': 'multipart/form-data' }

// Retorna todos os produtos cadastrados
const index = (params, callback) => {
  Vue.axios.get(PRODUCTS, { params })
    .then(res => {
      if (typeof res.data.meta !== 'undefined') {
        callback(res.data.products, res.data.meta.pagination)
      } else {
        callback(res.data.products)
      }
    })
    .catch(errorHandling)
}

// Retorna os dados de um produto
const find = (id, callback) => {
  Vue.axios.get(PRODUCTS + '/' + id)
    .then(res => {
      callback(res.data)
    })
    .catch(errorHandling)
}

// Busca pelos dados do produto com base em sua slug
const findBySlug = (slug, callback) => {
  index({ filter_attrs: { slug } }, products => {
    callback(products[0])
  })
}

// Cria um novo produto
const store = (data, callback, errorCallback) => {
  Vue.axios.post(PRODUCTS, data, { headers })
    .then(callback)
    .catch(errorCallback)
}

// Atualiza os dados do produto
const update = (id, data, callback, errorCallback) => {
  data.append('_method', 'PUT')
  Vue.axios.post(PRODUCTS + '/' + id, data, { headers })
    .then(callback)
    .catch(errorCallback)
}

// Remove o produto
const destroy = (id, callback) => {
  Vue.axios.delete(PRODUCTS + '/' + id)
    .then(callback)
    .catch(errorHandling)
}

export default {
  index,
  find,
  findBySlug,
  store,
  update,
  destroy
}
